import React, { useState } from 'react'
import {
  DateInput,
  ImageUpload,
  ModalWrapper,
  SelectField,
  StyledButton,
  TextFields,
} from '../../../../../../components'
import { Divider, Typography } from '@mui/material'
import './AddEmployee.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { getImageURL, urls } from '../../../../../../shared/config'
import { uploadImageToS3 } from '../../../../../../shared/config/S3Utils'
import { useGlobal, usePostApi } from '../../../../../../shared'
import { useDispatch, useSelector } from 'react-redux'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import {
  CloseCommonSuccess,
  CommonSuccess,
  QRCodeDisplay,
} from '../../School/SchoolRegistration/components/Steps'
import { InfoField } from '../../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../../shared/utils/constants'

export const VanDriverForm = ({ open, handleClose, title, teacher, customRole, userSchoolId }) => {
  const [success, setSuccess] = useState(false)
  const [qrOpen, setOpenQR] = useState(false)
  // const [empID, setEmpId] = useState(null)
  const { postApi } = usePostApi()
  const dispatch = useDispatch()
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const [vanID, setVanID] = React.useState(null)
  const data = useSelector((state) => state.global.SchoolDInfo)
  const initialValues = {
    schoolName: '',
    name: '',
    type: '',
    highestEducation: '',
    contactNumber: '',
    emergencyNumber: '',
    salary: '',
    gender: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    bonus: '',
    benefitAmount: '',
    benefitCategory: '',
    joiningDate: '',
    employeeImage: '',
    email: '',
    password: '',
    employee_dob: '',
  }

  const handleFileChange = (event, fieldName) => {
    const selectedFile = event.target.files[0]
    formik.setFieldValue(fieldName, selectedFile)
  }

  const handleStringInputChange = (fieldName) => (e) => {
    const stringValue = e.target.value.replace(/[^a-zA-Z\s]/g, '')
    formik.setFieldValue(fieldName, stringValue)
  }
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '')
    formik.setFieldValue(fieldName, numericValue)
  }
  const handleCLoseSuccess = () => {
    setSuccess(false)
    handleClose()
  }

  const genderOptions = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
  ]
  // const typeOptions = [
  //   { label: 'Admin', value: 'Admin' },
  //   { label: 'Staff', value: 'Staff' },
  //   { label: 'Driver', value: 'Driver' },
  // ]

  const validationSchema = Yup.object({
    // schoolName: Yup.string().required('School Name is required'),
    name: Yup.string().required('Name is required'),
    highestEducation: Yup.string().required('Education is required'),
    contactNumber: Yup.string().required('Phone Number is required'),
    salary: Yup.string().required('Salary is required'),
    email: Yup.string().required('Email is required'),
    gender: Yup.string().required('Gender is required'),
    joiningDate: Yup.string().required('Joining Date is required'),
    employee_dob: Yup.string().required('Dob is required'),
  })
  const validationSchema1 = Yup.object({
    // schoolName: Yup.string().required('School Name is required'),
    salary: Yup.string().required('Salary is required'),
    // joiningDate: Yup.string().required('Joining Date is required'),
    name: Yup.string().required('Name is required'),
    // type: Yup.string().required('Type is required'),
    contactNumber: Yup.string().required('Phone Number is required'),
    gender: Yup.string().required('Gender is required'),
    email: Yup.string().required('Email is required'),
  })
  const handleTeacher = () => {
    dispatch(setLoader(true))
    validationSchema
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        if (customRole != 'Admin') {
          if (!formik.values.schoolName) {
            toast.error('School is required')
            dispatch(setLoader(false))
            return
          }
        }
        if (formik.values.employeeImage) {
          await uploadImageToS3(formik.values.employeeImage, 'driver')
        }
        if (
          !/^\d{10}$/.test(formik.values.contactNumber) ||
          formik.values.contactNumber.startsWith('0')
        ) {
          toast.error('Invalid Phone Number!')
          dispatch(setLoader(false))
          return
        }
        if (formik.values.zipCode && formik.values.zipCode.length !== 6) {
          toast.error('Zipcode must be 6 digits!')
          dispatch(setLoader(false))
          return
        }
        const step3Data = {
          school_id: customRole == 'Admin' ? userSchoolId : formik.values.schoolName,
          employee_name: formik.values.name,
          employee_email: formik.values.email,
          employee_education: formik.values.highestEducation,
          employee_gender: formik.values.gender,
          employee_contact_number: formik.values.contactNumber,
          ...(formik.values.employeeImage
            ? { employee_avatar: getImageURL('driver', formik.values.employeeImage.name) }
            : {}),
          employee_salary: formik.values.salary,
          employee_joining_date: formik.values.joiningDate,
          ...(formik.values.address1 ? { employee_address: formik.values.address1 } : {}),
          ...(formik.values.address2 ? { employee_address_two: formik.values.address2 } : {}),
          ...(formik.values.city ? { employee_city: formik.values.city } : {}),
          ...(formik.values.state ? { employee_state: formik.values.state } : {}),
          ...(formik.values.zipCode ? { employee_pincode: formik.values.zipCode } : {}),
          employee_type: 'Driver',
          employee_password: formik.values.password,
          employee_dob: formik.values.employee_dob,
        }
        try {
          const response = await postApi(urls.VAN_DRIVER_POST, step3Data)
          console.log(response)
          if (response.status === 201 || response.status === 200) {
            const { driver_id } = response.data
            setVanID(driver_id)
            toast.success('Driver Added Successfully!')
            dispatch(setRefreshPage(true))
            setSuccess(true)
            dispatch(setLoader(false))
          } else {
            toast.error(response.message)
            dispatch(setLoader(false))
          }
        } catch (error) {
          console.error('Error occurred while submitting:', error)
          toast.error('Something Went Wrong!')
          dispatch(setLoader(false))
        }
      })
      .catch((error) => {
        if (error instanceof Yup.ValidationError) {
          error.inner.forEach((err) => {
            toast.error(err.message)
          })
        }
        dispatch(setLoader(false))
      })
  }

  const handleSubmit = () => {
    validationSchema1
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        if (customRole != 'Admin') {
          if (!formik.values.schoolName) {
            toast.error('School is required')
            dispatch(setLoader(false))
            return
          }
        }
        if (
          !/^\d{10}$/.test(formik.values.contactNumber) ||
          formik.values.contactNumber.startsWith('0')
        ) {
          toast.error('Invalid Phone Number!')
          dispatch(setLoader(false))
          return
        }
        if (formik.values.zipCode && formik.values.zipCode.length !== 6) {
          toast.error('Zipcode must be 6 digits!')
          dispatch(setLoader(false))
          return
        }
        let newAvatarUrl = ''

        if (formik.values.employeeImage instanceof File) {
          try {
            newAvatarUrl = await uploadImageToS3(formik.values.employeeImage, 'employee')
            // newAvatarUrl is now: https://bucket.s3.../timestamp-filename.jpg
          } catch (uploadErr) {
            console.error('Image upload failed:', uploadErr)
            toast.error('Failed to upload new profile picture. Please try again.')
            return // ← important: stop if upload fails
          }
        }
        const responseBody = {
          school_id: customRole == 'Admin' ? userSchoolId : formik.values.schoolName,
          employee_name: formik.values.name,
          employee_salary: formik.values.salary,
          employee_joining_date: formik.values.joiningDate,
          employee_email: formik.values.email,
          employee_gender: formik.values.gender,
          employee_contact_number: formik.values.contactNumber,
          employee_avatar: newAvatarUrl || '',
          ...(formik.values.address1 ? { employee_address: formik.values.address1 } : {}),
          ...(formik.values.address2 ? { employee_address_two: formik.values.address2 } : {}),
          ...(formik.values.city ? { employee_city: formik.values.city } : {}),
          ...(formik.values.state ? { employee_state: formik.values.state } : {}),
          ...(formik.values.zipCode ? { employee_pincode: formik.values.zipCode } : {}),
          employee_type: 'Driver',
          employee_password: formik.values.password,
          employee_dob: formik.values.employee_dob,
        }
        postApi(urls.EMPLOYEE_POST, responseBody)
          .then((response) => {
            if (response.status == 201 || response.status == 200) {
              toast.success('Van Driver Added Successfully!')
              dispatch(setLoader(false))
              dispatch(setRefreshPage(true))
              handleClose()
            } else {
              console.log('error:', response)
              toast.error(response?.message)
              // toast.error(response?.error?.message)
            }
          })
          .catch((error) => {
            toast.error(error)
            dispatch(setLoader(false))
          })
      })
      .catch((error) => {
        if (error instanceof Yup.ValidationError) {
          error.inner.forEach((err) => {
            toast.error(err.message)
          })
        }
        dispatch(setLoader(false))
      })
  }

  const formik = useFormik({
    initialValues,
    validationSchema: teacher ? validationSchema : validationSchema1,
    onSubmit: teacher ? handleTeacher : handleSubmit,
  })

  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  if (success) {
    return (
      <>
        <ModalWrapper adminAdd open={success} handleClose={handleCLoseSuccess} width={'431px'}>
          <div
            style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '18px' }}
          >
            <CommonSuccess />
            <CloseCommonSuccess
              handleClose={handleCLoseSuccess}
              hnhleOpen={() => setOpenQR(true)}
            />
          </div>
        </ModalWrapper>
        {qrOpen && (
          <QRCodeDisplay
            name={formik.values.firstName || data?.driver_first_name}
            handleClose={() => setOpenQR(false)}
            open={qrOpen}
            value={vanID}
          />
        )}
      </>
    )
  }
  return (
    <ModalWrapper open={open} handleClose={handleClose} title={title} width={'fit-content'}>
      <div className="add-employee">
        <Typography mb={2} className="form-heading">
          Personal Information
        </Typography>
        <div>
          <ImageUpload
            label={'Avatar'}
            selectedImage={
              formik.values.employeeImage && URL.createObjectURL(formik.values.employeeImage)
            }
            onFileChange={(e) => handleFileChange(e, 'employeeImage')}
          />
          {customRole == 'Admin' || customRole === 'Superadmin' ? (
            <InfoField label={'School'} value={userSchoolName} width={'100%'} />
          ) : (
            <SelectField
              label={'School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              required
              width={'100%'}
              name="schoolName"
              value={formik.values.schoolName}
              onChange={(selectedOption) => formik.setFieldValue('schoolName', selectedOption)}
            />
          )}

          <div className="text-fields">
            <TextFields
              width={'100%'}
              label={'Name'}
              placeholder={'Enter Name'}
              name={'name'}
              value={formik.values.name}
              required
              onChange={handleStringInputChange('name')}
            />
            {teacher ? (
              <TextFields
                required
                label={'Highest Education'}
                placeholder={'Enter Education'}
                name={'highestEducation'}
                value={formik.values.highestEducation}
                onChange={formik.handleChange}
              />
            ) : (
              <></>
              // <SelectField
              //   required
              //   label={'Type'}
              //   options={typeOptions}
              //   width={'100%'}
              //   containerWidth={'46%'}
              //   value={formik.values.type}
              //   onChange={(value) => formik.setFieldValue('type', value)}
              //   name="type"
              // />
            )}
          </div>

          {/* {!teacher && (
            <TextFields
              label={'Highest Education'}
              name={'highestEducation'}
              value={formik.values.highestEducation}
              onChange={formik.handleChange}
            />
          )} */}
          <div className="text-fields">
            <TextFields
              width={'100%'}
              label={'Email'}
              placeholder={'example@gmail.com'}
              required
              name={'email'}
              value={formik.values.email}
              onChange={formik.handleChange}
            />
          </div>
          <div className="text-fields">
            <TextFields
              width={'100%'}
              label={'Password'}
              placeholder={''}
              required
              name={'password'}
              value={formik.values.password}
              onChange={formik.handleChange}
            />
          </div>
          <DateInput
            required
            label={'Date of Birth'}
            value={formik.values.employee_dob}
            name={'employee_dob'}
            onChange={formik.handleChange}
          />
          {!teacher && (
            <SelectField
              width={'100%'}
              label={'Gender'}
              required
              options={genderOptions}
              value={formik.values.gender}
              onChange={(value) => formik.setFieldValue('gender', value)}
            />
          )}
          <div className="text-fields">
            <TextFields
              width={teacher ? '50%' : '100%'}
              required
              placeholder={'1234567890'}
              label={'Contact Number'}
              value={formik.values.contactNumber}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/[^0-9]/g, '')
                formik.handleChange({
                  target: {
                    name: 'contactNumber',
                    value: numericValue,
                  },
                })
              }}
              name="contactNumber"
            />
            {teacher && (
              <SelectField
                placeholder={'Select Gender'}
                width={'100%'}
                label={'Gender'}
                required
                options={genderOptions}
                value={formik.values.gender}
                onChange={(value) => formik.setFieldValue('gender', value)}
              />
            )}
          </div>
          <div className="text-fields">
            <TextFields
              width={'50%'}
              name={'address1'}
              placeholder={'Enter Address 1'}
              label={'Address'}
              value={formik.values.address1}
              onChange={formik.handleChange}
            />
            <TextFields
              name={'address2'}
              label={'Address 2'}
              placeholder={'Enter Address 2'}
              value={formik.values.address2}
              onChange={formik.handleChange}
            />
          </div>
          <div className="text-fields">
            <TextFields
              name={'city'}
              label={'City'}
              placeholder={'Enter City'}
              width={'150px'}
              value={formik.values.city}
              onChange={handleStringInputChange('city')}
            />
            <TextFields
              name={'state'}
              label={'State'}
              placeholder={'Enter State'}
              width={'120px'}
              value={formik.values.state}
              onChange={handleStringInputChange('state')}
            />
            <TextFields
              name={'zipCode'}
              label={'Zip Code'}
              placeholder={'XXXXXX'}
              width={'120px'}
              value={formik.values.zipCode}
              onChange={handleInputChange('zipCode')}
            />
          </div>
        </div>

        <Divider />
        <Typography mt={2} mb={2} className="form-heading">
          Other Information
        </Typography>
        <TextFields
          placeholder={'₹60,000'}
          name={'salary'}
          label={'Salary'}
          required
          value={formik.values.salary}
          onChange={handleInputChange('salary')}
        />
        {/* {!teacher && ! (
          <>
            <TextFields
              name={'bonus'}
              label={'Bonus'}
              value={formik.values.bonus}
              onChange={formik.handleChange}
            />
            <SelectField
              label={'Benefit Category'}
              width={'100%'}
              value={formik.values.benefitCategory}
              onChange={(value) => formik.setFieldValue('benefitCategory', value)}
            />
            <TextFields
              name={'benefitAmount'}
              label={'Benefit Amount'}
              value={formik.values.benefitAmount}
              onChange={formik.handleChange}
            />
          </>
        )} */}
        <DateInput
          required
          label={'Joining Date'}
          value={formik.values.joiningDate}
          name={'joiningDate'}
          onChange={formik.handleChange}
        />

        <div className="add-employee-btns">
          <div className="in-a-row">
            <Typography onClick={handleClose} className="cancel-btn">
              Cancel
            </Typography>
            <StyledButton onClick={teacher ? handleTeacher : handleSubmit}>Add</StyledButton>
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}
